export default "__VITE_ASSET__Bvfjn8vf__"